<script setup>
import {computed, ref, watch} from 'vue'
import {useItemDataStore} from '@/stores/itemData'

import CollectionFilterControlTypeColour from "./CollectionFilterControlTypeColour.vue"
import CollectionFilterControlTypeCurrency from "./CollectionFilterControlTypeCurrency.vue"
import CollectionFilterControlTypeDate from "./CollectionFilterControlTypeDate.vue"
import CollectionFilterControlTypeDateDate from "./CollectionFilterControlTypeDateDate.vue"
import CollectionFilterControlTypeDateTimeLocal from "./CollectionFilterControlTypeDateTimeLocal.vue"
import CollectionFilterControlTypeEmail from "./CollectionFilterControlTypeEmail.vue"
import CollectionFilterControlTypeInternalLink from "./CollectionFilterControlTypeInternalLink.vue"
import CollectionFilterControlTypeNumber from "./CollectionFilterControlTypeNumber.vue"
import CollectionFilterControlTypeRelationship from "./CollectionFilterControlTypeRelationship.vue"
import CollectionFilterControlTypeRelationshipManyToMany from "./CollectionFilterControlTypeRelationshipManyToMany.vue"
import CollectionFilterControlTypeSelect from "./CollectionFilterControlTypeSelect.vue"
import CollectionFilterControlTypeTelephone from "./CollectionFilterControlTypeTelephone.vue"
import CollectionFilterControlTypeText from "./CollectionFilterControlTypeText.vue"
import CollectionFilterControlTypeTime from "./CollectionFilterControlTypeTime.vue"
import CollectionFilterControlTypeUrl from "./CollectionFilterControlTypeUrl.vue"

const props = defineProps({
    item: Object
})

const itemDataStore = useItemDataStore()

const field = ref(null)

watch(
    () => props.item?.fieldId,
    async (fieldId) => {
        if (!fieldId) {
            field.value = null
            return
        }
        field.value = await itemDataStore.get({
            tableName: 'modulestructure',
            id: fieldId
        })
    },
    {immediate: true}
)

const componentName = computed(() => {
    let type = field.value?.type

    if (props.item.fieldId === null) {
        type = 'relationshipManyToMany'
    }

    switch (type) {
        case 'checkbox':
            return ''
        case 'color':
            return CollectionFilterControlTypeColour
        case 'currency':
            return CollectionFilterControlTypeCurrency
        case 'date':
            return CollectionFilterControlTypeDate
        case 'dateDate':
            return CollectionFilterControlTypeDateDate
        case 'datetime-local':
            return CollectionFilterControlTypeDateTimeLocal
        case 'email':
            return CollectionFilterControlTypeEmail
        case 'file':
        case 'image':
            return ''
        case 'internalLink':
            return CollectionFilterControlTypeInternalLink
        case 'number':
            return CollectionFilterControlTypeNumber
        case 'relationshipOneToMany':
            return CollectionFilterControlTypeRelationship
        case 'relationshipManyToMany':
            return CollectionFilterControlTypeRelationshipManyToMany
        case 'select':
            return CollectionFilterControlTypeSelect
        case 'tel':
            return CollectionFilterControlTypeTelephone
        case 'text':
        case 'texteditor':
        case 'textarea':
            return CollectionFilterControlTypeText
        case 'time':
            return CollectionFilterControlTypeTime
        case 'url':
            return CollectionFilterControlTypeUrl
        default:
            return null
    }
})
</script>

<template>
    <component :is="componentName" :field="field" :item="item"/>
</template>